export const updateMarkerStart = (duration: number, updatedStart: number): number => {
    const start = Math.min(Math.max(0, updatedStart), duration - 1);
    
    return start;
};
